import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { InputTextModule } from 'primeng/inputtext';
import { InsuranceProvidersService } from '../../service/insurance-providers.service';
import { Provider } from '../../api/provider';
import { ProviderCardComponent } from '../common/provider-card/provider-card.component';
import { Router } from '@angular/router';
import { NgxTranslateModule } from 'src/app/translate.module';
import { LanguageService } from '../../service/language.service';
import { TranslateService } from '@ngx-translate/core';
import { languages } from '../../constants/languages';
import { showErrorToast } from '../../utilities/toast-utils';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-insurance-providers',
    standalone: true,
    imports: [
        CommonModule,
        CardModule,
        NgxTranslateModule,
        InputTextModule,
        ButtonModule,
        DividerModule,
        ProviderCardComponent,
    ],
    templateUrl: './insurance-providers.component.html',
    styleUrl: './insurance-providers.component.scss',
})
export class InsuranceProvidersComponent {
    insuranceProviders!: Provider[];
    languages: any[] = languages;
    selectedLanguage!: string;

    constructor(
        private providerService: InsuranceProvidersService,
        private router: Router,
        private languageService: LanguageService,
        private translateService: TranslateService,
        private messageService: MessageService
    ) { }

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    setLanguage(language: string) {
        this.translateService.use(language);
        this.languageService.setLanguage(language);
    }

    ngOnInit() {
        this.fetchInsuranceProviders();
        this.initializeLocale();
    }

    fetchInsuranceProviders() {
        this.providerService.fetchAllInsuranceProviders().subscribe({
            next: (value) => {
                this.insuranceProviders = value;
            },
            error: (err) => {
                showErrorToast(this.translateService.instant(err.error.messageKey), this.messageService,this.translateService)
            },
        });
    }

    addInsuranceProviderClicked() {
        this.router.navigate(['/home/insurance-providers/new']);
    }
}
